import type { AccountType } from '@dhl/mdp-api'
import { toProduct, type ProductDefinitionDto } from '~/common/model/capabilities'
import { useDataAsyncCall } from '~/api/admin-api'
import { BusinessTypeEnum } from '~/api/constants'
import { buildUrlWithParameters } from '~/common/util/url'

export const useProducts = (
  businessUnit: string | undefined,
  fromCountry: string | undefined,
  accountType?: AccountType
) => {
  const [productDefinitions, { isLoading }] = useDataAsyncCall<ProductDefinitionDto[]>(
    buildUrlWithParameters('products', { fromCountry, businessUnit, businessProduct: true, accountType })
  )

  const productFilter = (item: any) => {
    const key = item.key ?? item
    return businessUnit === BusinessTypeEnum.CCC ? key !== 'DFY-INT-B2C' : true
  }

  const products = (productDefinitions ?? []).filter(productFilter).map(toProduct)

  return { products, isLoading }
}
